import settings from '@/constants/constants';
import type { apiCustomerPortalContract } from '@montugroup/circuit-api-contracts';
import { isMontuError } from '@montugroup/circuit-shared/utils/typscript-helpers';
import {
  Alert,
  AlertTitle,
  Button,
  LoadingButton,
  Link as MUILink,
  Stack,
  Typography,
} from '@montugroup/design-system';
import { UMEDS_CUSTOMER_SERVICE_NUMBER_DISPLAY, UMEDS_CUSTOMER_SERVICE_NUMBER_INTL } from '@montugroup/frontend-common';
import { isErrorResponse } from '@ts-rest/core';

export function CheckoutButton({
  disabled,
  loading,
  onClick,
  error,
}: {
  disabled: boolean;
  loading: boolean;
  onClick: () => void;
  error: unknown;
}) {
  if (
    isErrorResponse<typeof apiCustomerPortalContract.createCheckout>(error) &&
    isMontuError<typeof apiCustomerPortalContract.createCheckout>(error) &&
    error?.body?.error?.code === 'INVALID_EMAIL'
  ) {
    return (
      <Alert severity="error">
        <AlertTitle>Invalid email</AlertTitle>
        <Stack direction={'column'} gap={1}>
          <Typography variant="body2">Please contact support to update your email to continue checkout</Typography>

          <Button variant="contained" href={`tel:${UMEDS_CUSTOMER_SERVICE_NUMBER_INTL}`}>
            Call us {UMEDS_CUSTOMER_SERVICE_NUMBER_DISPLAY}
          </Button>
          <Button
            component={(props) => <MUILink {...props} target="_blank" />}
            variant="outlined"
            href={`${settings.support.site.url}/articles/36042289598745-Contact-uMeds`}
            rel="noopener"
          >
            Message us
          </Button>
        </Stack>
      </Alert>
    );
  }

  return (
    <LoadingButton
      type="submit"
      sx={{ marginTop: 2, width: '100%' }}
      color="primary"
      variant="contained"
      size="large"
      disabled={disabled}
      loading={loading}
      onClick={onClick}
    >
      Proceed to checkout
    </LoadingButton>
  );
}
